import type { IModuleListSection, IModuleSimpleTextSection } from "./generated/contentful";

export function isModuleSimpleTextSection(entry: any): entry is IModuleSimpleTextSection {
  return entry.sys.contentType.sys.id === "moduleSimpleTextSection";
}

export function isModuleListSection(entry: any): entry is IModuleListSection {
  return entry.sys.contentType.sys.id === "moduleListSection";
}
